import React from 'react';
import Header from '../../components/header/index';
import Footer from '../../components/footer/index';
import CommonBtn from '../../components/btn/index';
import HomeVideo from '../../components/video/index';
import Download from "../download/index";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Row, Col, Carousel, message } from 'antd';
import home_bg_img from '../../static/imgs/home_bg.png';
import home_bg_ssms_img from '../../static/imgs/home_bg_ssms.png';
import home_bg_qsms_img from '../../static/imgs/home_bg_qsms.png';
import global from '../../http/common';
import http from '../../http/http';
import model_qsms from '../../static/imgs/qsms_bg.png';
import model_ssms from '../../static/imgs/ssms_bg.png';
import arrow_ic from '../../static/imgs/arrow_ic.png';
import yxal_ic from '../../static/imgs/yxal_ic.png';

import './index.css'
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alData: [{
        src: "https://res.cyberui.cn/static/mp4/location_layout.mp4",
        title: "元素位置适配",
        message: "让设计元素的位置能够适应不同尺寸的屏幕",
        href: "/words/如何设置元素的位置",
        type: "location_layout"
      }, {
        src: "https://res.cyberui.cn/static/mp4/size_layout.mp4",
        title: "元素大小适配",
        message: "让设计元素的大小能够适应不同尺寸的屏幕",
        href: "/words/如何设置元素的大小",
        type: "size_layout"
      }, {
        src: "https://res.cyberui.cn/static/mp4/group_layout.mp4",
        title: "元素组合适配",
        message: "让多个设计元素组合在一起后，也能适应不同尺寸的屏幕",
        href: "/words/如何设置元素的组合",
        type: "group_layout"
      }, {
        src: "https://res.cyberui.cn/static/mp4/special_layout.mp4",
        title: "异形屏适配",
        message: "让原型设计在刘海屏，挖孔屏，水滴屏等异形屏中也能完美显示",
        href: "/words/如何进行异形屏的适配",
        type: "special_layout"
      }, {
        src: "https://res.cyberui.cn/static/mp4/icon_layout.mp4",
        title: "图标适配",
        message: "内置多种风格免费矢量图标库",
        href: "/words/如何添加内置图标到你的设计",
        type: "icon_layout"
      }, {
        src: "https://res.cyberui.cn/static/mp4/img_layout.mp4",
        title: "图片资源适配",
        message: "支持2x,3x,4x三种适配比例的图片资源，原型在真机演示时自动匹配最优图片资源",
        href: "/words/如何添加自定义图片到你的设计",
        type: "img_layout"
      }],
      close_header_message: true,
      demoProductArr: []
    };
    this.plainData = {
      scrollTimer: null,
      scroll_t1: 0,
      scroll_t2: 0,
      videoIsPlay: true,
      homeVideos: null
    }
  }
  componentDidMount () {
    if (!this.props.home_case_data || !Object.keys(this.props.home_case_data).length) {
      this.requestCaseList("1", "0", (dataArr) => {
        this.props.SAVE_HOME_CASE_DATA(dataArr);
        this.setState({
          demoProductArr: dataArr
        });
      });
    } else {
      let dataArr = this.props.home_case_data;
      this.setState({
        demoProductArr: dataArr
      });
    }
  }
  componentWillReceiveProps (nextProps) {
    this.setState({
      close_header_message: nextProps.close_header_message
    });
  }
  render () {
    return (
      <div className='index_wrap noscrollbar' style={{ overflow: "auto", height: "100%", width: "100%", position: "absolute", left: "0px", top: "0px" }} onScroll={this.onScroll.bind(this)}>
        <Download ref="download"></Download>
        <div className="home_content">
          <div className="home_content_start">
            <div className={"home_bg_img"}>
              <img src={home_bg_img}></img>
            </div>
            <Header index="0" background="transparent"></Header>
            <div className="home_content_item home_content_first box-padding-vertical-lg">
              <div className="xl_text title">支持终端适配的高保真原型设计工具</div>
              <div className="home_content_first_message_bg">
                <div className="shoal_white_color c_text">让你的原型设计适配不同屏幕尺寸</div>
                <div className="shoal_white_color c_text">适配矩形/异形屏，适配深色/浅色模式，适配多平台原生特性</div>
                <div className="shoal_white_color c_text">距离真实的APP只差数据</div>
              </div>
              <div className="home_content_first_btn_bg">
                <CommonBtn type="common" text="立刻开始" newStyle={{ color: "white", background: "var(--blue_highlight_color)" }} btnClick={this.startWithLogin.bind(this)}></CommonBtn>
                <CommonBtn className="download_app_btn" type="border" text="下载客户端" newStyle={{ border: "1px solid white", color: "white" }} btnClick={this.showDownload.bind(this)}>
                </CommonBtn>
              </div>
            </div>
          </div>
          <div className="home_content_item home_content_second box-padding-vertical box-padding-horizontal">
            <div className="l_text">原型设计多屏适配</div>
            <div className="horizontal_bg">
              <Row className="al_row" gutter={[16]}>
                {
                  this.state.alData.map((data, index) => {
                    let videoItem = [];
                    let refName = "layoutVideo_" + index;
                    if (data.src && data.src != "") {
                      videoItem = [
                        <HomeVideo ref={refName} src={data.src} key={"layoutVideo_" + index} type={data.type} autoPlay={false} videoStyle={{ width: "100%", height: "auto" }}></HomeVideo>
                      ];
                    }
                    return (
                      <Col md={12} sm={12} xs={24} lg={8} key={"al_item_" + index}>
                        <div className="al_item" onMouseEnter={this.alItemMouseEnter.bind(this, refName)} onMouseLeave={this.alItemMouseLeave.bind(this, refName)}>
                          <Link className="link" to={data.href}></Link>
                          <div className="img_bg">
                            {
                              videoItem
                            }
                          </div>
                          <div className="bottom">
                            <div className="title">{data.title}</div>
                            <div className="message">{data.message}</div>
                          </div>
                        </div>
                      </Col>
                    )
                  })
                }
              </Row>
            </div>
            <div className="startbtn_bg">
              <CommonBtn type="common" text="立即体验" newStyle={{ background: "var(--blue_highlight_color)", color: "white" }} btnClick={this.startWithCase.bind(this)}></CommonBtn>
            </div>
          </div>
          <div className="gray_bg box-padding-horizontal">
            <div className="home_content_third box-padding-vertical">
              <Carousel ref="model_carousel" className="model_carousel" afterChange={this.carouselOnChange.bind(this)} autoplay={true} dots={false} style={{ width: "100%" }}>
                <div className="model_carousel_item dark_model box-padding-horizontal box-padding-vertical">
                  <img className="model_bg" src={model_ssms}></img>
                  <div className="model_carousel_item_next" onClick={this.nextCarouselItem.bind(this)}>
                    <img src={arrow_ic}></img>
                  </div>
                  <Row className="row" style={{ height: "100%" }}>
                    <Col md={24} sm={24} xs={24}>
                      <div className="message_item">
                        <div className="l_text title">深色模式适配</div>
                        <div className="message">
                          <div className="shoal_white_color c_text">自动适配深色模式与独立的深色模式属性设置</div>
                        </div>
                        <CommonBtn type="common" text="立即体验" newStyle={{ background: "var(--blue_highlight_color)", color: "white", marginTop: "20px" }} btnClick={this.startWithCase.bind(this,1)}></CommonBtn>
                      </div>
                    </Col>
                    <Col md={24} sm={24} xs={24}>
                      <div className="message_item">
                        <img src={home_bg_ssms_img} className="img"></img>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="model_carousel_item light_model box-padding-horizontal box-padding-vertical">
                  <img className="model_bg" src={model_qsms}></img>
                  <div className="model_carousel_item_next" onClick={this.nextCarouselItem.bind(this)}>
                    <img src={arrow_ic}></img>
                  </div>
                  <Row className="light_row row" style={{ height: "100%" }}>
                    <Col md={24} sm={24} xs={24}>
                      <div className="message_item">
                        <div className="l_text title">浅色模式适配</div>
                        <div className="message">
                          <div className="c_text">自动适配浅色模式与独立的浅色模式属性设置</div>
                        </div>
                        <CommonBtn type="common" text="立即体验" newStyle={{ background: "var(--blue_highlight_color)", color: "white", marginTop: "20px" }} btnClick={this.startWithCase.bind(this, 1)}></CommonBtn>
                      </div>
                    </Col>
                    <Col md={24} sm={24} xs={24}>
                      <div className="message_item">
                        <img src={home_bg_qsms_img} className="img"></img>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Carousel>
            </div>
            <div className="home_content_four box-padding-vertical">
              <Row className="row" gutter={[16, 32]} style={{ height: "100%" }}>
                <Col sm={24} xs={24} md={24} lg={24} style={{ height: "50%" }}>
                  <div className="bottom_message">
                    <div className="l_text">原生效果，无限真实</div>
                    <div className="message marginTop">当使用iOS或Android客户端浏览原型设计时，赛百UI运行库会将其转换为iOS或Android原生应用，使其具备等同于原生应用的性能(如：拍照，定位，打开通讯录等本地终端能力。</div>
                    <div className="bottom">
                      <CommonBtn type="common" text="立即体验" newStyle={{ background: "var(--blue_highlight_color)", color: "white" }} btnClick={this.startWithCase.bind(this)}></CommonBtn>
                    </div>
                  </div>
                </Col>
                <Col className="col" offset={4} sm={8} xs={8} md={8} lg={8} style={{ height: "50%" }}>
                  <div className="device">
                    <div className="video_bg">
                      <HomeVideo ref={"ysxgVideo_0"} src={"https://res.cyberui.cn/static/mp4/ysxg_jjt.mp4"} key={"ysxg_1"} type={"ysxg_1"} videoStyle={{ maxWidth: "80%", height: "auto" }}></HomeVideo>
                    </div>
                    {/* <span className="source">演示案例来自于<a>sasa</a>制作的<a>基金通</a></span> */}
                    <div className="device_btn" onClick={this.startWithPreview.bind(this, 0)}>
                      <img src={yxal_ic}></img>
                      <CommonBtn type="border" text="运行案例" btnClick={this.startWithPreview.bind(this, 0)} newStyle={{ border: "none", width: "auto", marginTop: "1px", marginLeft: "5px" }}></CommonBtn>
                    </div>
                  </div>
                </Col>
                <Col className="col" sm={8} xs={8} md={8} lg={8} style={{ height: "50%" }}>
                  <div className="device">
                    <div className="video_bg">
                      <HomeVideo ref={"ysxgVideo_1"} src={"https://res.cyberui.cn/static/mp4/ysxg_xyjz.mp4"} key={"ysxg_2"} type={"ysxg_2"} videoStyle={{ maxWidth: "80%", height: "auto" }}></HomeVideo>
                    </div>
                    {/* <span className="source">演示案例来自于<a>wusha</a>制作的<a>小鱼记账</a></span> */}
                    <div className="device_btn" onClick={this.startWithPreview.bind(this, 1)}>
                      <img src={yxal_ic}></img>
                      <CommonBtn type="border" text="运行案例" btnClick={this.startWithPreview.bind(this, 1)} newStyle={{ border: "none", width: "auto", marginTop: "1px", marginLeft: "5px" }}></CommonBtn>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="home_content_four box-padding-vertical home_content_five">
              <Row className="row" gutter={[16, 0]} style={{ height: "100%" }}>
                <Col sm={24} xs={24} style={{ height: "50%" }}>
                  <div className="bottom_message marginBottom">
                    <div className="l_text">所见即所得的设计过程</div>
                    <div className="message marginTop">内置丰富组件，简单拖拽，设计就是如此简单</div>
                    <div className="message">完善的适配设置，随时切换适配机型，查看设计效果</div>
                    <div className="bottom">
                      <CommonBtn type="common" text="立即体验" newStyle={{ background: "var(--blue_highlight_color)", color: "white" }} btnClick={this.startWithCase.bind(this)}></CommonBtn>
                    </div>
                  </div>
                </Col>
                <Col sm={24} xs={24} style={{ height: "50%" }}>
                  <div className="top">
                    <HomeVideo ref={"designVideo_1"} src={"https://res.cyberui.cn/static/mp4/design.mp4"} key={"design"} type={"design"} videoStyle={{ maxWidth: "80%", height: "auto" }}></HomeVideo>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </div >
    );
  }
  nextCarouselItem () {
    let model_carousel = this.refs.model_carousel;
    if (model_carousel) {
      model_carousel.next();
    }
  }
  requestCaseList (kindNo, orderType, callback) {
    //kindNo 0表示教程案例 1表示用户分享案例
    //orderType 0推荐 1表示最新
    http.get("/public/api/productCases", {
      kindNo: kindNo,
      orderType: orderType
    }, response => {
      if (response && response.result && response.result.length) {
        let dataArr = response.result;
        console.log(dataArr);
        callback(dataArr);
      }
    });
  }
  isScrollEnd (scrollTop) {
    this.plainData.scroll_t2 = scrollTop;
    if (this.plainData.scroll_t2 == this.plainData.scroll_t1) {
      console.log('滚动结束了');
      this.playAllVideo();
    }
  }
  onScroll (e) {
    let target = e.target;
    if (target) {
      clearTimeout(this.plainData.scrollTimer);
      this.plainData.scrollTimer = setTimeout(() => {
        this.isScrollEnd(target.scrollTop);
      }, 1000);
      this.plainData.scroll_t1 = target.scrollTop;
      this.pauseAllVideo();
    }
  }
  playAllVideo () {
    if (this.plainData.videoIsPlay == false) {
      this.plainData.videoIsPlay = true;
      for (let key in this.refs) {
        if (key.indexOf("Video") != -1) {
          let video = this.refs[key];
          if (video.state.autoPlay) {
            video.play();
          }
        }
      }
    }
  }
  pauseAllVideo () {
    if (this.plainData.videoIsPlay == true) {
      this.plainData.videoIsPlay = false;
      for (let key in this.refs) {
        if (key.indexOf("Video") != -1) {
          let video = this.refs[key];
          if (video.state.autoPlay) {
            video.pause();
          }
        }
      }
    }
  }
  alItemMouseEnter () {
    let refName = arguments[0];
    let event = arguments[1];
    event.stopPropagation();
    let video = this.refs[refName];
    if (video) {
      video.play();
    }
  }
  alItemMouseLeave () {
    let refName = arguments[0];
    let event = arguments[1];
    event.stopPropagation();
    let video = this.refs[refName];
    if (video) {
      video.pause();
    }
  }
  startWithCase (type) {
    //以测试案例为ID跳转IDE
    let isLogin = global.isLogin();
    if (this.state.demoProductArr && this.state.demoProductArr.length) {
      let data = null;
      for (var i = 0; i < this.state.demoProductArr.length; i++) {
        var map = this.state.demoProductArr[i];
        if (type == 1 && map.productName == "基金通") {
          data = map;
        }
        if (!type && map.productName == "小鱼记账") {
          data = map;
        }
      }
      if (global.isPhone()) {
        message.info('暂时只支持电脑端打开编辑器，快去尝试下吧~');
      } else {
        if (isLogin) {
          window.lookProductBtnClick(data);//已经登录 直接进入
        } else {
          window.visitorLoginBtnClick(function () {
            window.lookProductBtnClick(data);
          });//未登录 游客登录进入
        }
      }
    }
  }
  startWithPreview (index) {
    //弹出预览框
    //以测试案例为ID跳转IDE
    let isLogin = global.isLogin();
    if (this.state.demoProductArr && this.state.demoProductArr.length) {
      let data = null;
      for (var i = 0; i < this.state.demoProductArr.length; i++) {
        var map = this.state.demoProductArr[i];
        if (index == 0 && map.productName == "基金通") {
          data = map;
        }
        if (index == 1 && map.productName == "小鱼记账") {
          data = map;
        }
      }
      // let data = this.state.demoProductArr[index];
      // console.log(data);
      if (global.isPhone()) {
        data.isPhone = true;
      }
      if (isLogin) {
        window.previewProductBtnClick(data);//已经登录 直接进入
      } else {
        window.visitorLoginBtnClick(function () {
          window.previewProductBtnClick(data);
        });//未登录 游客登录进入
      }
    }
  }
  startWithLogin () {
    if (global.isPhone()) {
      message.info('暂时只支持电脑端打开编辑器，快去尝试下吧~');
    } else {
      var isLogin = global.isLogin();
      if (isLogin) {
        window.hrefProductHome();//已经登录 直接进入
      } else {
        window.visitorLoginBtnClick();//未登录 游客登录进入
      }
    }
  }
  carouselOnChange (current) {
    // console.log(current);
  }
  showDownload () {
    if (global.isPhone()) {
      window.location.href = http.hostUrl + http.contextName + "/pages/download.html";
    } else {
      if (this.refs.download) {
        this.refs.download.showDownload();
      }
    }
  }
}
function mapStateToProps (state) {
  return {
    close_header_message: state.close_header_message,
    home_case_data: state.home_case_data
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    SAVE_HOME_CASE_DATA: (data) => {
      dispatch({ type: 'SAVE_HOME_CASE_DATA', home_case_data: data })
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);